// copied from old support wallboard

/* eslint-disable max-classes-per-file */
import React, {
	useContext, createContext, useCallback, useState,
} from 'react';
import propTypes from 'prop-types';
import CanvasResize from 'react-canvas-resize';

const fireworkcolors = ['#CE93D8', '#CE93D8', '#90CAF9', '#80CBC4', '#A5D6A7', '#FFF59D', '#FFCC80'];

const rnd = (a, b) => Math.random() * (b - a) + a;

class Firework {
	constructor(delay = 0) {
		this.start = Date.now() + delay;
		this.renderTime = 4500;
	}

	get done() {
		return Date.now() > this.start + this.renderTime;
	}

	render(ctx, time) {
		if (this.done) return;
		if (time < this.start) return;
		const atime = time - this.start;

		if (atime < 1000) {
			this.renderRocket(ctx, atime / 1000);
		} else {
			this.renderStar(ctx, (atime - 1000) / 3500);
		}
	}

	renderRocket(ctx, t) {
		const { width } = ctx.canvas; const
			{ height } = ctx.canvas;

		if (!this._rocket) {
			this._rocket = {
				sx: Math.random() * 0.4 + 0.3,
				sy: Math.random() * 0.2 + 1,
				ex: Math.random() * 0.2 + 0.4,
				ey: Math.random() * 0.2 + 0.2,
				color: fireworkcolors[Math.floor(Math.random() * fireworkcolors.length)],
				flicker: Math.random() * 0.05 + 0.05,
			};
		}
		const rocket = this._rocket;

		const tcurve = (1 - Math.abs(Math.pow(t - 1, 2)));
		const ttrail = (1 - Math.abs(Math.pow(t - 1.05, 2)));
		const x = (1 - tcurve) * rocket.sx + tcurve * rocket.ex;
		const y = (1 - tcurve) * rocket.sy + tcurve * rocket.ey;
		const tx = (1 - ttrail) * rocket.sx + ttrail * rocket.ex;
		const ty = (1 - ttrail) * rocket.sy + ttrail * rocket.ey;

		ctx.save();
		ctx.beginPath();
		ctx.strokeStyle = rocket.color;
		ctx.lineWidth = 5;
		ctx.moveTo(x * width, y * height);
		ctx.lineTo(tx * width, ty * height);
		ctx.stroke();
		ctx.restore();
	}

	generateStarflares(ctx, count) {
		const { width } = ctx.canvas; const
			{ height } = ctx.canvas;
		const star = this._star || {};

		this._starflares = Array(count || 250).fill(0).map(() => {
			const d = Math.random() * Math.PI * 2; const
				p = Math.random() * Math.min(width, height);
			return {
				x: star.ox,
				y: star.oy,
				vx: p * Math.cos(d),
				vy: p * Math.sin(d),
				color: star.color,
				sizeMin: 0,
				sizeMax: 20,
			};
		});
	}

	renderStar(ctx, t) {
		const { width, height } = ctx.canvas;

		if (!this._star) {
			const rocket = this._rocket || {};
			this._star = {
				ox: (rocket.ex || Math.random() * 0.2 + 0.4) * width,
				oy: (rocket.ey || Math.random() * 0.2 + 0.2) * height,
				color: rocket.color || '#CC4433',
				time: Date.now(),
			};
		}
		if (!this._starflares) this.generateStarflares(ctx);
		const star = this._star; let
			starflares = this._starflares;

		if (t > 0.5) starflares = starflares.filter(() => Math.random() > t * 2 - 1);

		const dtime = Date.now() - star.time;
		star.time = Date.now();
		starflares.forEach((f) => {
			const spread = 'spread' in f ? f.spread : 3;
			f.vx /= Math.pow(1.002, dtime);
			f.vy = f.vy / Math.pow(1.002, dtime) + dtime * height / 1e4;
			f.x += f.vx * dtime / 1000; f.y += f.vy * dtime / 1000;
			ctx.save();
			ctx.beginPath();
			ctx.strokeStyle = f.color;
			ctx.lineWidth = 'size' in f ? f.size : 'sizeMin' in f ? Math.round(rnd(f.sizeMin, f.sizeMax)) : 1;
			ctx.moveTo(f.x + rnd(-spread, spread), f.y + rnd(-spread, spread));
			ctx.lineTo(f.x + rnd(-spread, spread), f.y + rnd(-spread, spread));
			ctx.stroke();
			ctx.restore();
		});
	}
}

const fireworkContext = createContext();

export default function useFirework() {
	return useContext(fireworkContext);
}

export function FireworkProvider(props) {
	const { children } = props;

	const [, setList] = useState([]);

	const push = useCallback((delay = 0) => {
		const firework = new Firework(delay);

		setList((l) => ([
			...l,
			firework,
		]));
	}, []);

	const handleDraw = useCallback(({ canvas, box, now }) => {
		const ctx = canvas.getContext('2d');

		ctx.setTransform(1, 0, 0, 1, 0, 0);
		ctx.clearRect(0, 0, box.fullWidth, box.fullHeight);

		setList((l) => l.filter((f) => {
			if (f.done) return false;
			f.render(ctx, now);
			return true;
		}));
	}, []);

	return (
		<fireworkContext.Provider value={push}>
			<CanvasResize
				ratio={1}
				fillCanvas
				onDraw={handleDraw}
				style={{
					pointerEvents: 'none',
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100vw',
					height: '100vh',
					zIndex: 99,
				}}
			/>
			{children}
		</fireworkContext.Provider>
	);
}

FireworkProvider.propTypes = {
	children: propTypes.node.isRequired,
};
